import BackgroundImage from "../../../components/ui/BackgroundImage";
import bgImage from "../assets/images/memory-bg.webp";
import GameBoard from "./GameBoard";
import GameProgress from "./GameProgress";
import Header from "./Header";
import { usePairsGame } from "../hooks/use-pairs-game";
import Scenarios from "./Scenarios";
import { GAME_CONFIG } from "../constants";
import { motion, AnimatePresence } from "framer-motion";

const PairsMinigame = ({ className = "" }: { className?: string }) => {
  const {
    cards, // Array of cards in the current level/grid
    stats, // Game stats (moves, time, score, etc.)
    flipCard, // Function to flip a card by its ID
    currentGridSize, // Current board size (e.g. 4x4, 6x6, 8x8)
    isGameOver, // Boolean flag if game is over

    isLevelComplete, // Boolean flag if current level is completed
    isRunning, // Boolean flag if game is running
    resetGame, // Resets everything back to level 1
    nextLevel, // Moves to next level
    startGame, // Starts the game
  } = usePairsGame({
    // ✅ Supported config options right now:

    startLevel: 1, // (optional) start from specific level instead of 1

    onWin: (stats) => {
      // Triggered when player wins (finishes all levels)
      console.log("Game won!", stats);
    },

    onLose: (stats) => {
      // Triggered when player loses (e.g. no attempts left, time expired)
      console.log("Game lost!", stats);
    },

    onMatch: ({ firstId, secondId, stats }) => {
      // Triggered when a pair is successfully matched
      console.log(`Match! Cards: ${firstId}, ${secondId}`, stats);
    },

    onMismatch: ({ firstId, secondId, stats }) => {
      // Triggered when a pair does NOT match
      console.log(`Mismatch! Cards: ${firstId}, ${secondId}`, stats);
    },
  });

  return (
    <BackgroundImage
      imageSrc={bgImage}
      className={`w-full h-screen flex items-center justify-center overflow-hidden  ${className}`}
    >
      <AnimatePresence>
        <motion.div
          key="animated-box"
          initial={{ opacity: 0, y: 50 }} // start position (below)
          animate={{ opacity: 1, y: 0 }} // visible
          exit={{ opacity: 0, y: 50 }} // leave down
          transition={{ duration: 0.4, ease: "easeOut" }}
          className=""
        >
          <main className="bg-gradient-to-r from-[#161b26]/95 via-[#2c364a]/90 to-[#161b26]/95 rounded-[56px] p-6 relative">
            <div className="border-[1px] border-white/15 rounded-[46px] p-8">
              <Header
                titleWords={[
                  { word: "PAIRS" },
                  { word: "MINIGAME", isHighlighted: true },
                ]}
                onClose={() => {}}
              />
              <GameProgress
                timeLeft={stats.timeLeft}
                points={stats.points}
                levelStage={stats.level}
                className="my-4"
              />
              <div>
                <GameBoard
                  cards={cards}
                  gridSize={currentGridSize}
                  flipCard={flipCard}
                  isGameOver={isGameOver}
                />
              </div>

              {(isGameOver || isLevelComplete || !isRunning) && (
                <Scenarios
                  isRunning={isRunning}
                  stats={stats}
                  gridSize={GAME_CONFIG.GRID_SIZE}
                  isGameOver={isGameOver}
                  isLevelComplete={isLevelComplete}
                  nextLevel={nextLevel}
                  resetGame={resetGame}
                  startGame={startGame}
                />
              )}
            </div>
          </main>
        </motion.div>
      </AnimatePresence>
    </BackgroundImage>
  );
};

export default PairsMinigame;
